<template>
  <div class="content">
    <div class="container-fluid">
      <Breadcrumb />
      <div class="row">
        <div class="col-parent col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <!-- <h1>Admin</h1>
            <router-link to="/admin/blog">blog</router-link>
            <router-link to="/admin/news">news</router-link> -->
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Breadcrumb } from './layout/'
export default {
  name: 'volcan-content',
  components: {
    Breadcrumb
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// shared/content.vue